<template>
  <AuthLayout>
    <template #form>
      <router-link to="/welcome" class="auth-brand">
        <img :src="logoUrl" alt="Logo Saineo" class="auth-brand__mark" />
        <span class="auth-brand__name">saineo</span>
      </router-link>

      <h1 class="auth-title">Créez votre compte</h1>
      <p class="auth-subtitle">
        Dernière étape : renseignez votre email, votre pseudo et choisissez un mot de passe.
      </p>

      <form class="auth-form" @submit.prevent="register">
        <v-text-field
          clearable
          label="Email"
          placeholder="johndoe@gmail.com"
          type="email"
          v-model="email"
          variant="outlined"
          rounded="lg"
          hide-details="auto"
          class="auth-input"
        ></v-text-field>

        <v-text-field
          clearable
          label="Pseudo"
          placeholder="Votre pseudo"
          v-model="username"
          variant="outlined"
          rounded="lg"
          hide-details="auto"
          class="auth-input"
        ></v-text-field>

        <v-text-field
          label="Mot de passe"
          :append-inner-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
          :rules="[rules.required, rules.min]"
          :type="show1 ? 'text' : 'password'"
          @click:append="show1 = !show1"
          clearable
          v-model="password"
          variant="outlined"
          rounded="lg"
          hide-details="auto"
          class="auth-input"
        ></v-text-field>

        <div class="disclaimer">
          <input type="checkbox" id="disclaimer-check" v-model="disclaimerAccepted" required />
          <label for="disclaimer-check">
            Les recommandations fournies par l'application ne remplacent pas l'avis d'un professionnel de santé.
          </label>
        </div>

        <v-btn
          rounded="lg"
          size="large"
          type="submit"
          variant="elevated"
          class="auth-btn"
          :disabled="!disclaimerAccepted"
        >
          Créer mon compte
        </v-btn>

        <div class="auth-footer">
          <span>Déjà un compte ?</span>
          <router-link to="/login">Se connecter</router-link>
        </div>
      </form>
    </template>
  </AuthLayout>

  <v-snackbar v-if="errorMessage" v-model="errorMessage" color="error" top right>
    {{ errorMessage }}
  </v-snackbar>
</template>

<script>
import AuthLayout from '@/components/PublicPages/AuthLayout.vue';
import logoUrl from '@/../assets/logo.png';
import { formStore } from '@/store/register_store';
import { getAuth, createUserWithEmailAndPassword, updateProfile } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { db } from "@/firebase";

export default {
  name: 'FinalRegister',
  components: { AuthLayout },
  data: () => ({
    logoUrl,
    disclaimerAccepted: false,
    email: '',
    username: '',
    password: '',
    responses: formStore.responses,
    errorMessage: '',
    show1: false,
    rules: {
      required: value => !!value || 'Required.',
      min: v => v.length >= 8 || 'Min 8 characters',
    },
  }),
  methods: {
    async register() {
      try {
        const auth = getAuth();
        const cred = await createUserWithEmailAndPassword(auth, this.email, this.password);
        if (cred?.user && this.username) {
          await updateProfile(cred.user, { displayName: this.username });
        }

        const userData = {
          ...this.responses,
          userid: cred.user.uid,
          username: this.username,
          email: this.email,
        };
        await setDoc(doc(db, "User", cred.user.uid), userData);

        this.$router.push('/');
      } catch (error) {
        console.error(error);
        switch (error.code) {
          case 'auth/email-already-in-use':
            this.errorMessage = 'Cet email est déjà utilisé';
            break;
          case 'auth/invalid-email':
            this.errorMessage = 'Email invalide';
            break;
          case 'auth/weak-password':
            this.errorMessage = 'Mot de passe trop faible';
            break;
          default:
            this.errorMessage = 'Une erreur est survenue';
            break;
        }
      }
    },
  },
};
</script>

<style scoped>
  .auth-brand {
    display: inline-flex;
    align-items: center;
    gap: 12px;
    text-decoration: none;
    color: inherit;
    font-weight: 700;
    letter-spacing: -0.02em;
    margin-bottom: 16px;
  }

  .auth-brand__mark {
    width: 34px;
    height: 34px;
    object-fit: contain;
    display: block;
  }

  .auth-title {
    margin: 0;
    font-size: clamp(2rem, 4vw, 2.8rem);
    font-weight: 600;
    letter-spacing: -0.03em;
    color: #1A1615;
    line-height: 120%;
  }

  .auth-subtitle {
    margin: 6px 0 28px;
    color: #3c3f46;
    line-height: 1.6;
  }

  .auth-form {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  .auth-btn {
    background: #1A1615 !important;
    color: #ffffff !important;
    border-radius: 999px !important;
    padding: 14px 34px;
    box-shadow: none !important;
    text-transform: none;
    font-weight: 700;
    font-family: inherit;
    letter-spacing: 0;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    text-align: center !important;
  }

  .auth-btn:hover {
    opacity: 0.85;
    transform: translateY(-2px);
  }

  .auth-footer {
    display: flex;
    gap: 6px;
    align-items: center;
    font-size: 0.95rem;
    color: #3c3f46;
  }

  .auth-footer a {
    color: #111111;
    font-weight: 600;
    text-decoration: none;
  }

  :deep(.auth-input .v-field) {
    border-radius: 16px;
  }

  .disclaimer {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    font-size: 0.88rem;
    color: #3c3f46;
    line-height: 1.5;
  }

  .disclaimer input[type="checkbox"] {
    margin-top: 3px;
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    accent-color: #1A1615;
    cursor: pointer;
  }

  .disclaimer label {
    cursor: pointer;
  }
</style>
